// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__TLRmC","left":"InfoRow_left__1fG4i"};